import React from 'react';
import { 
  Box, 
  List, 
  ListItem, 
  ListItemButton, 
  ListItemText, 
  Paper, 
  Typography,
  Divider
} from '@mui/material';

/**
 * A sidebar component for module navigation
 * @param {Object} props - Component props
 * @param {Array} props.sections - Array of section objects with id, title, and content
 * @param {String} props.activeSection - ID of the currently active section
 * @param {Function} props.onSectionChange - Function to call when a section is selected
 * @param {String} props.moduleTitle - Title of the module
 * @returns {JSX.Element} - The rendered component
 */
const ModuleSidebar = ({ sections, activeSection, onSectionChange, moduleTitle }) => {
  return (
    <Paper 
      elevation={2} 
      sx={{ 
        width: '100%', 
        height: '100%',
        borderRadius: 2,
        overflow: 'hidden'
      }}
    >
      <Box sx={{ p: 2, bgcolor: 'primary.main', color: 'white' }}>
        <Typography variant="subtitle1" fontWeight="bold">
          {moduleTitle}
        </Typography>
      </Box>
      <Divider />
      <List sx={{ py: 0 }}>
        {sections.map((section) => (
          <ListItem 
            key={section.id} 
            disablePadding
            divider
          >
            <ListItemButton
              selected={activeSection === section.id}
              onClick={() => onSectionChange(section.id)}
              sx={{
                '&.Mui-selected': {
                  bgcolor: 'rgba(25, 118, 210, 0.08)',
                  borderLeft: '4px solid',
                  borderColor: 'primary.main',
                },
                '&:hover': {
                  bgcolor: 'rgba(25, 118, 210, 0.04)',
                },
                pl: activeSection === section.id ? 1.5 : 2,
              }}
            >
              <ListItemText 
                primary={section.title} 
                primaryTypographyProps={{
                  fontSize: 14,
                  fontWeight: activeSection === section.id ? 'medium' : 'regular',
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};

export default ModuleSidebar;
